export default "__VITE_ASSET__FyzGfnqi__"